// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"033c6cf0","337":"69b8a558","453":"89f5187c","455":"41060a93"}[chunkId] + ".chunk.js";
};